<template>
  <div class="pt-3">
    <div
      class="relative w-full h-auto transition-opacity duration-300"
      :class="{ 'opacity-30': disabled || readonly }"
    >
      <textarea
        :value="value"
        :disabled="disabled"
        :readonly="readonly"
        :rows="`${rows}`"
        :class="{ 'has-value': !!value }"
        class="
          mt-input
          pt-1.5
          px-0
          w-full
          h-full
          text-dark text-sm
          font-medium
          leading-4
          bg-transparent
          border-none
          outline-none
          focus:outline-none
          shadow-none
          resize-none
          focus:ring-0
        "
        placeholder=" "
        v-bind="maxLength !== undefined ? { maxlength: `${maxLength}` } : {}"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
        @input="$emit('change', $event.target.value)"
      ></textarea>

      <label
        class="
          absolute
          -top-0.5
          left-0
          w-full
          h-full
          text-dark text-opacity-40 text-sm
          border-b border-dark border-opacity-60
          pointer-events-none
        "
      >
        <span class="absolute top-2 text-sm transition-all duration-300">{{
          label
        }}</span>
      </label>
    </div>
    <div v-if="maxLength !== undefined" class="flex justify-end mt-1">
      <div
        class="ml-auto text-dark text-opacity-45 text-xs font-normal leading-4"
      >
        {{ length }} / {{ maxLength }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';

@Component
export default class TextAreaField extends Vue {
  @Model('change', { type: String }) value!: string;
  @Prop({ type: [String, Object], required: true }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: Boolean, default: false }) disabled!: string;
  @Prop({ type: Boolean, default: false }) readonly!: string;
  @Prop({ type: [Number, String], default: 3 }) rows!: number | string;
  @Prop({ type: [Number, String] }) maxLength?: number | string;

  private get length(): number {
    return this.value?.length || 0;
  }
}
</script>
